<template>
  <div>
    <b-card-code class="mt-2 principal">
      <b-button
        id="btn-excel"
        ref="btnexcel"
        variant="primary"
        size="sm"
        style="
          margin-right: 1%;
          background: #37ef00 !important;
          border-color: #37ef00 !important;
        "
        @click="cargarFacturas((excel_btn = '1'))"
      >
        <font-awesome-icon icon="fa-solid fa-file-excel" />
      </b-button>
      <b-button
        id="btn-pdf"
        variant="danger"
        size="sm"
        @click="cargarFacturas((excel_btn = ''), (pdf_btn = '1'))"
      >
        <font-awesome-icon icon="fa-solid fa-file-pdf" />
      </b-button>
      <b-row class="mt-2">
        <!-- <b-col md="3">
          <b-form-group>
            <label>Código:</label>
            <b-form-input
              v-model="codigo"
              placeholder="Buscar por código"
              type="text"
              class="d-inline-block"
            />
          </b-form-group>
        </b-col> -->
        <!-- <b-col md="3">
          <b-form-group>
            <label>Código tarjeta:</label>
            <b-form-input
              v-model="codigo_tarjeta"
              placeholder="Buscar por código tarjeta"
              type="text"
              class="d-inline-block"
            />
          </b-form-group>
        </b-col> -->
        <b-col md="3">
          <b-form-group>
            <label>Razón social:</label>
            <b-form-input
              v-model="razon_social"
              placeholder="Buscar por razón social"
              type="text"
              class="d-inline-block"
            />
          </b-form-group>
        </b-col>
        <b-col md="3">
          <b-form-group>
            <label>Número de factura:</label>
            <b-form-input
            v-model="numero_factura"
            placeholder="Buscar por número de factura"
            type="text"
            class="d-inline-block"
            />
          </b-form-group>
        </b-col>
        <b-col md="2">
          <b-form-group>
            <label>Identificación:</label>
            <b-form-input
              v-model="identificacion"
              placeholder="Buscar por identificación"
              type="text"
              class="d-inline-block"
            />
          </b-form-group>
        </b-col>
        <b-col md="2">
            <b-form-group>
                <label class="text-sm">Fecha desde (emisión):</label>
                <flat-pickr
                        id="fecha_desde"
                        v-model="fecha_desde"
                        :config="configdateTimePicker"
                        class="form-control"
                        placeholder="Seleccionar fecha..."
                />
            </b-form-group>
        </b-col>
        <b-col md="2">
            <b-form-group>
                <label class="text-sm">Fecha hasta: (emisión)</label>
                <flat-pickr
                        id="fecha_hasta"
                        v-model="fecha_hasta"
                        :config="configdateTimePicker"
                        class="form-control"
                        placeholder="Seleccionar fecha..."
                />
            </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4" class="pb-2">
          <b-button variant="primary" size="sm" @click="filtrar">
            <font-awesome-icon icon="fa-solid fa-magnifying-glass" /> Consultar
          </b-button>
        </b-col>
      </b-row>
    </b-card-code>

    <b-overlay :show="mostrarLoader" opacity="0.50" rounded="sm">
      <b-button
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        v-b-modal.modal-1
        variant="outline-primary"
        id="btn-modal"
        hidden
    >
      {{ modalActivo }}
    </b-button>
      <b-modal
          ref="modal-1"
          id="modal-1"
          ok-only
          size="lg"
          ok-title="Aceptar"
          @ok="validacionDocumentos"
      >
        <b-carousel
            ref='carrusel'
            v-model="slide"
            no-wrap
            controls
            no-animation
            :interval='0'
            @sliding-start="onSlideStart"
            @sliding-end="onSlideEnd"
        >
          <b-carousel-slide v-for="(item, index) in items_archivos" style="padding:35px;" :key="index">
            <h6 style="margin-bottom: -13px;">{{ item }}</h6>
          </b-carousel-slide>
        </b-carousel>
        <div id="app">
          <div class="app-header">
            <template v-if="isLoading">
              Loading...
            </template>

            <template v-else>
                      <span v-if="showAllPages">
                        {{ pageCount }} page(s)
                      </span>

              <span v-else>
                <button :disabled="page <= 1" @click="page--">❮</button>

                {{ page }} / {{ pageCount }}

                <button :disabled="page >= pageCount" @click="page++">❯</button>
              </span>
              <label class="right">
                <input v-model="showAllPages" type="checkbox">
                Mostrar todas las páginas
              </label>
            </template>
          </div>
          <div class="app-content" id="contenedor-pdf">
            <vue-pdf-embed
                ref="pdfRef"
                :source="base64_data"
                :page="page"
                @rendered="handleDocumentRender"
            />
          </div>
        </div>
      </b-modal>

      <b-card-code class="principal">
        <b-col cols="12" class="pr-0 pl-0 mt-2">
          <b-table
            v-if="items.length > 0"
            bordered
            striped
            responsive
            :per-page="perPage"
            :current-page="currentPage"
            :items="items"
            :fields="fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :filter="filter"
            :filter-included-fields="filterOn"
            small
            @filtered="onFiltered"
          >
            <template #cell(cliente)="data">
              <b-link
                :to="{
                  name: 'editpersona',
                  params: { token: data.item.cliente.token },
                }"
              >
                 {{ data.item.cliente.razon_social }}
              </b-link>
            </template>
            <template #cell(numero_documento)="data">
              <b-link
                :to="{
                  name: 'consultar_factura',
                  params: { tokenFactura: data.item.token },
                }"
              >
                 {{ data.item.tipo_documento + " " + data.value }}
              </b-link>
              <b-badge
                  v-if="data.item.fecha_sincronizacion"
                  variant="success"
                  v-b-tooltip.hover
                  title="Sincronizado con contifico"
              >
                  <feather-icon
                      icon="CloudIcon"
                      class="mr-25"
                  />
              </b-badge>
              <b-badge
                  v-else
                  variant="danger"
                  v-b-tooltip.hover
                  title="No sincronizado con contifico"
              >
                  <feather-icon
                      icon="CloudOffIcon"
                      class="mr-25"
                  />
              </b-badge>
            </template>
            <template #cell(fecha_emision)="data">
              {{ obtenerFechaFormateada(data.value) }}
            </template>
            <template v-slot:cell(total)="data">
                <span>{{ data.value | formattedDollars }}</span>
            </template>
            <template v-slot:cell(iva)="data">
                <span>{{ data.value | formattedDollars }}</span>
            </template>
            <template v-slot:cell(subtotal_0)="data">
                <span>{{ data.value | formattedDollars }}</span>
            </template>
            <template #cell(estado)="data">
              <b-badge :variant="estados_facturas[1][data.value]">
                {{ estados_facturas[0][data.value] }}
              </b-badge>
            </template>
            <template #cell(paymentezId)="data">
              <a v-if="data.value">{{ data.value }}</a>
              <a v-else>N/A</a>
            </template>
            <template #cell(tarjeta.codigo)="data">
              <a v-if="data.value">{{ data.value }}</a>
              <a v-else>N/A</a>
            </template>
          </b-table>

          <div v-else class="text-center">
            <p>No se encontraron registros</p>
          </div>
        </b-col>

        <b-col cols="12" class="mb-2">
          <b-pagination
            v-if="items.length > 0"
            v-model="currentPageModificado"
            :total-rows="totalRows"
            :per-page="perPage"
            first-number
            last-number
            :small="true"
            class="mb-0"
            align="center"
            prev-class="prev-item"
            next-class="next-item"
            @change="paginacion"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </b-col>
      </b-card-code>
    </b-overlay>
  </div>
</template>

<script>
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCard,
  BImg,
  BCardHeader,
  BCardGroup,
  BCardTitle,
  BLink,
  VBTooltip,
  BButtonGroup,
  BCarouselSlide,
  BCarousel
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import BCardCode from "@core/components/b-card-code";
import axios from "@/libs/axios";
import actions from "@/assets/utils/utils";
import vSelect from "vue-select";
import $ from "jquery";
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed';

import flatPickr from "vue-flatpickr-component";
import 'flatpickr/dist/flatpickr.css';
import { Spanish } from 'flatpickr/dist/l10n/es.js';

import { BOverlay } from "bootstrap-vue";
import Vue from "vue";
import moment from 'moment';

export default {
  components: {
    VuePdfEmbed,
    BCarouselSlide,
    BCarousel,
    BLink,
    BCardHeader,
    BCardGroup,
    BCardTitle,
    BCardCode,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BImg,
    vSelect,
    BOverlay,
    flatPickr,
    BButtonGroup,
  },
  directives: {
    'b-tooltip': VBTooltip, 
    Ripple,
  },
  data() {
    return {
      login_user: "",
      perPage: 15,
      pageOptions: [3, 5, 10],
      totalRows: 1,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      fields: [
        {
          key: "fecha_emision",
          label: "Emisión",
          thClass: "text-center",
          tdClass: 'modelo-cell'
        },
        {
          key: "numero_documento",
          label: "# Documento",
          thClass: "text-center",
          tdClass: 'modelo-cell'
        },
        {
          key: "estado",
          label: "Estado",
          thClass: "text-center",
          tdClass: "text-left modelo-cell",
        },
        {
          key: "cliente",
          label: "Razón Social",
          thClass: "text-center",
          tdClass: 'modelo-cell'
        },
        {
          key: "total",
          label: "Total",
          thClass: "text-center",
          tdClass: "text-right modelo-cell",
        },
      ],
      items: [],
      items_archivos: [
        'Comprobante de pago', 'Retención'
      ],
      estados_facturas: [
        {
          'P': "Pendiente",
          'C': "Cobrado",
          'G': "Pagado",
          'A': "Anulado"
        },
        {
          'P': "light-warning",
          'C': "light-success",
          'G': "light-info",
          'A': "light-danger",
        },
      ],

      nombres: "",
      apellidos: "",
      correo: "",
      username: "",

      estado: "all",

      estados: [
        { value: "1", text: "Activo" },
        { value: "0", text: "Inactivo" },
        { value: "all", text: "Todos" },
      ],
      mostrarLoader: false,

      codigo: "",
      razon_social: "",

      configdateTimePicker: {
          enableTime: false,
          dateFormat: 'd/m/Y',
          locale: Spanish,
      },
      fecha_desde: "",
      fecha_hasta: "",
      identificacion: "",
      numero_factura: "",
      base64_rentencion: "",
      base64_comprobante: "",

      //pdf embed
      isLoading: true,
      page: null,
      pageCount: 1,
      showAllPages: true,
      base64_data: '',
      modalActivo: '',
      slide: 0,
      codigo_tarjeta: '',
      currentPageModificado: 1,
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
  },
  created() {
    this.comprobarPermisos();
    $("#btn-excel").remove();
    $("#btn-pdf").remove();
    $("#btn-print").remove();
    $("#eliminar-viajes").remove();
    $("#btn-abrir-caja").remove();
  },
  mounted() {
    actions.setearTitulo("");
    const params = new URLSearchParams(window.location.search);
    this.codigo_tarjeta = params.get("codigo") || "";
    this.cargarFacturas();
    $("#contenedor-botones").append($("#btn-excel")).append($("#btn-pdf"));
  },
  methods: {
    paginacion(value) {
      const pagina_actual = value;
      const limite_superior = value * this.perPage;
      const limite_inferior = (value - 1) * this.perPage;
      const desde = limite_inferior;
      const hasta = limite_superior;
      this.cargarFacturas("", "", desde, hasta, pagina_actual);
    },
    validarPregunta(token) {
      this.$swal({
        title: 'Liberación de boletos',
        text: '¿Está seguro que desea validar los documentos?',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Validar',
        confirmButtonColor: '#d9534f',
        showDenyButton: true, // Activa un tercer botón
        denyButtonText: 'Rechazar',
        denyButtonColor: '#f0ad4e',
      }).then(result => {
        // if (result.value) {
        //   this.validacionDocumentos(token)
        // }
        if (result.isConfirmed) {
          this.validacionDocumentos(token=token, true); // Acción para validar
        } else if (result.isDenied) {
          this.validacionDocumentos(token=token, false); // Acción para rechazar
        }
      })
    },
    validacionDocumentos(token, validacion){
      console.log('esto es un testing...')
      console.log(token)
      this.mostrarLoader = true;
      axios
        .post("api", {
          query: `mutation validacionDocumentos($token_orden: String!, $validacion: Boolean!){
                    validacionDocumentos(tokenOrden:$token_orden, validacion: $validacion){
                        status,
                        message
                    }
                }`,
          variables: {
            token_orden: token,
            validacion: validacion,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.data.validacionDocumentos.status === "success") {
              this.cargarFacturas();
            }
          }
          this.mostrarLoader = false;
        });
    },
    onSlideStart(slide) {
      if(slide === 0){
        this.base64_data = 'data:application/pdf;base64,' + this.base64_comprobante
      }
      else{
        this.base64_data = 'data:application/pdf;base64,' + this.base64_rentencion
      }
    },
    onSlideEnd(slide) {
      // this.previsualizarAnexoFirmado(this.items_archivos[slide].itoken);
      if(slide === 0){
        this.base64_data = 'data:application/pdf;base64,' + this.base64_comprobante
      }
      else{
        this.base64_data = 'data:application/pdf;base64,' + this.base64_rentencion
      }

    },
    handleDocumentRender() {
      this.isLoading = false
      this.pageCount = this.$refs.pdfRef.pageCount
    },
    obtenerDocumentos(token_orden){
      this.mostrarLoader = true;
      axios
        .post("api", {
          query: `query getArchivosOrden($token_orden: String!){
                    getArchivosOrden(tokenOrden:$token_orden){
                        dataarchivoretencion
                        dataarchivocomprobante
                        status,
                        message
                    }
                }`,
          variables: {
            token_orden: token_orden,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.data.getArchivosOrden.status === "success") {
              if (response.data.data.getArchivosOrden.dataarchivoretencion) {
                this.base64_rentencion = response.data.data.getArchivosOrden.dataarchivoretencion;
                this.base64_comprobante = response.data.data.getArchivosOrden.dataarchivocomprobante;
                var modal_open = document.getElementById("btn-modal");
                modal_open.click();
                this.modalActivo = true
                this.base64_data = 'data:application/pdf;base64,' + this.base64_comprobante
              }
            }
          }
          this.mostrarLoader = false;
        });
    },
    obtenerFechaFormateada(fecha) {
      return moment(fecha).format('DD/MM/YYYY');
    },
    comprobarPermisos() {
      if (
        localStorage.getItem("permisos").indexOf("ord_factura_consultar") === -1
      ) {
        this.$router.push({ name: "not-permitted" });
      }
    },
    filtrar() {
      this.cargarFacturas();
    },
    cargarFacturas(excel_btn = "", pdf_btn = "", desde = 0, hasta = 15, pagina_actual = 1) {
      this.mostrarLoader = true;
      axios
        .post("api", {
          query: `query getAllFacturas($codigo: String!, $codigoTarjeta: String!, $razonSocial: String!, $identificacion: String!, $numeroFactura: String!, $fechaCorteFin: String!, $fechaCorteInicio: String!, $excel: String!, $pdf: String!, $desde: Int!, $hasta: Int!){
                    getAllFacturas(codigo: $codigo, codigoTarjeta: $codigoTarjeta, razonSocial: $razonSocial, identificacion: $identificacion, numeroFactura: $numeroFactura, fechaCorteFin: $fechaCorteFin, fechaCorteInicio: $fechaCorteInicio, excel:$excel, pdf:$pdf, desde: $desde, hasta: $hasta){
                        facturas{
                            tipo_documento: tipoDocumento,
                            token,
                            fecha_emision: fechaEmision,
                            numero_documento: numeroDocumento,
                            estado,
                            numero_autorizacion: numeroAutorizacion,
                            descripcion,
                            subtotal_0: subtotal0,
                            subtotal_12: subtotal12,
                            iva,
                            servicio,
                            total,
                            cliente{
                              token,
                              razon_social: razonSocial,
                              identificacion
                            }
                            boletos_sincronizados: boletosSincronizados
                            contifico_id: contificoId
                            fecha_sincronizacion: fechaSincronizacion
                        },
                        dataarchivo,
                        total,
                        status,
                        message
                    }
                }`,
          variables: {
            codigo: this.codigo,
            codigoTarjeta: this.codigo_tarjeta,
            razonSocial: this.razon_social,
            identificacion: this.identificacion,
            numeroFactura: this.numero_factura,
            fechaCorteInicio: this.fecha_desde,
            fechaCorteFin: this.fecha_hasta,
            excel: excel_btn,
            pdf: pdf_btn,
            desde: desde,
            hasta: hasta,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.data.getAllFacturas.status === "success") {
              if (response.data.data.getAllFacturas.facturas) {
                this.items = response.data.data.getAllFacturas.facturas;
                this.totalRows = response.data.data.getAllFacturas.total;
                this.currentPage = 1;
                this.currentPageModificado = pagina_actual;
              } else {
                var data = response.data.data.getAllFacturas.dataarchivo;
                if (excel_btn === "1") {
                  actions.cargarArchivos(
                    data,
                    "Facturas.xlsx",
                    "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64"
                  );
                } else {
                  actions.cargarArchivos(
                    data,
                    "Facturas.pdf",
                    "data:application/pdf;base64"
                  );
                }
              }
            }
          }
          this.mostrarLoader = false;
        });
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    newUsuario() {
      this.$router.push({ name: "formusuario" });
    },
  },
};
</script>
<style>
.principal .card-header {
  display: none !important;
}
.principal .card-body {
  padding-bottom: 0 !important;
}
@media (min-width: 576px) {
  [dir] .table th,
  [dir] .table td {
    padding-left: 1%;
    padding-right: 1%;
  }
}
.modelo-cell {
  white-space: nowrap;
}

.vue-pdf-embed > div {
  margin-bottom: 8px;
  box-shadow: 0 2px 8px 4px rgba(0, 0, 0, 0.1);
}

.app-header {
  padding: 16px;
  box-shadow: 0 2px 8px 4px rgba(0, 0, 0, 0.1);
  background-color: #555;
  color: #ddd;
}

#contenedor-pdf {
  padding: 24px 16px;
  background-color: #DDD;
}

.right {
  float: right;
  color: #ddd;
}

body {
  margin: 0;
  padding: 0;
  background-color: #ccc;
}

div#app {
  overflow-x: auto;
  overflow-y: auto;
}
/* Estilo para la flecha "anterior" */
.carousel-control-prev-icon {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='black' viewBox='0 0 8 8'%3E%3Cpath d='M5.5 0l-4 4 4 4v-3h2v-2h-2v-3z'/%3E%3C/svg%3E");
}

/* Estilo para la flecha "siguiente" */
.carousel-control-next-icon {
  background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='black' viewBox='0 0 8 8'%3E%3Cpath d='M2.5 0v3h-2v2h2v3l4-4-4-4z'/%3E%3C/svg%3E");
}
</style>
